import { useState } from 'react';
import { supabase } from '../supabaseclient';

export default function Enxoval({ perfil }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Beneficiario: '',
    Endereco: '',
    Telefone: '', 
    Sexo_Bebe: 'Masculino'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase
      .from('Kit_enxoval') 
      .insert([{ 
        Beneficiario: formData.Beneficiario,
        Endereco: formData.Endereco,
        Telefone: formData.Telefone, 
        Sexo_Bebe: formData.Sexo_Bebe,
        Data_atual: new Date().toLocaleDateString('pt-BR'),
        Responsavel_Concessao: perfil?.nome || 'Operador'
      }]);

    if (error) {
      alert('Erro ao salvar: ' + error.message);
    } else {
      alert('✅ Kit Enxoval registrado com sucesso!');
      setFormData({ Beneficiario: '', Endereco: '', Telefone: '', Sexo_Bebe: 'Masculino' });
    }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-4 animate-in fade-in duration-500">
      <div className="bg-blue-900 p-8 rounded-t-[2rem] shadow-xl text-white">
        <h2 className="text-2xl font-black uppercase tracking-tight">Concessão de Kit Enxoval</h2>
        <p className="text-blue-300 text-[10px] font-bold uppercase tracking-widest">Fundo Social de Solidariedade</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-b-[2rem] shadow-xl space-y-6 border border-gray-100">
        <div className="space-y-4">
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-2 block mb-1">Nome da Beneficiária (Mãe)</label>
            <input 
              required
              className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 ring-blue-500 font-bold text-gray-700"
              value={formData.Beneficiario}
              onChange={(e) => setFormData({...formData, Beneficiario: e.target.value})}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase ml-2 block mb-1">Endereço (Opcional)</label>
              <input 
                className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 ring-blue-500 font-bold text-gray-700"
                value={formData.Endereco}
                onChange={(e) => setFormData({...formData, Endereco: e.target.value})}
              />
            </div>
            
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase ml-2 block mb-1">Telefone / WhatsApp (Opcional)</label>
              <input 
                placeholder="(00) 00000-0000"
                className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 ring-blue-500 font-bold text-gray-700"
                value={formData.Telefone}
                onChange={(e) => setFormData({...formData, Telefone: e.target.value})}
              />
            </div>
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-2 block mb-3">Sexo do Bebê</label>
            <div className="grid grid-cols-2 gap-4">
              {['Masculino', 'Feminino'].map((sexo) => (
                <button
                  key={sexo}
                  type="button"
                  onClick={() => setFormData({...formData, Sexo_Bebe: sexo})}
                  className={`p-4 rounded-2xl font-black uppercase text-xs transition-all ${
                    formData.Sexo_Bebe === sexo 
                    ? 'bg-blue-900 text-white shadow-lg scale-105' 
                    : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                  }`}
                >
                  {sexo === 'Masculino' ? '♂️ Menino' : '♀️ Menina'}
                </button>
              ))}
            </div>
          </div>
        </div>

        <button 
          type="submit"
          disabled={loading}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-black py-5 rounded-2xl shadow-lg transition-all uppercase tracking-widest text-sm disabled:opacity-50"
        >
          {loading ? 'Salvando...' : 'Salvar Registro'}
        </button>
      </form>
    </div>
  );
}
